export const AUTH_SCOPE = 'portal';
